import React from "react";
import { useTheme } from "@glossy";
import { IllustrationProps } from ".";

export default ({ colors: { base } }: IllustrationProps) => {
  const theme = useTheme();

  return (
    <svg viewBox="0 0 48 48" width="100%" height="100%">
      <path
        fill="none"
        stroke={theme.border}
        d="M41.5 16.5h-10v9c0 3.31-2.69 6-6 6h-9v10c0 3.31 2.69 6 6 6h19c3.31 0 6-2.69 6-6v-19c0-3.31-2.69-6-6-6Z"
      />
      <g fill={base}>
        <path d="M31.5 21.5v1.31h9.69v18.38H22.81V31.5H21.5v11h21v-21h-11z" />
        <path d="m32 35-2.79-4.79c-.36.28-.75.52-1.17.72l-3.92 8.97h15.76l-4.6-7.7L32 35Z" />
        <circle cx="37.25" cy="26.75" r="1.31" />
      </g>
      <rect
        width="31"
        height="31"
        x=".5"
        y=".5"
        fill="none"
        stroke={theme.border}
        rx="6"
        ry="6"
      />
      <path
        fill={base}
        d="M17.07 18.93c-.42 0-.83-.08-1.22-.22l-.85-.35a.713.713 0 0 1-.35-.92c.13-.33.51-.5.84-.37l.04.02.87.35c.7.31 1.45.13 1.58-.31l3.28-8c.13-.43-.31-1.05-.92-1.35L18.52 7c-.7-.31-1.45-.13-1.58.3l-1.71 4.29c-.16.34-.56.5-.91.35a.627.627 0 0 1-.32-.83l1.7-4.3c.48-1.23 2.06-1.62 3.5-1l1.8.7c1.34.39 2.11 1.78 1.72 3.12 0 .02-.01.05-.02.07l-3.32 8.1c-.5.77-1.39 1.21-2.31 1.13Zm-3 7.57c-.44 0-.88-.1-1.27-.31l-1.8-.7a2.485 2.485 0 0 1-1.72-3.07c0-.03.02-.05.02-.08l3.15-7.79a2.576 2.576 0 0 1 3.41-1.05l.88.35c.34.21.43.66.22.99a.72.72 0 0 1-.71.33l-.87-.35c-.7-.31-1.44-.09-1.58.3l-3.15 7.79c-.13.35.22 1 1 1.27l1.79.7c.31.14.66.19 1 .13.2-.05.38-.18.49-.35l1.57-3.94c.13-.38.54-.57.92-.44a.664.664 0 0 1 .44.92v.09l-1.71 3.94a2.36 2.36 0 0 1-1.44 1.22c-.2.04-.41.05-.61.05h-.03Z"
      />
    </svg>
  );
};
